/**
 * Utility functions for managing the ?openJourneyForm= URL parameter
 * Used when opening/closing journey form overlays
 */

export function setFormParam(formId: string) {
  const url = new URL(window.location.href);
  url.searchParams.set('openJourneyForm', formId);
  window.history.replaceState({}, '', url.toString());
}

export function clearFormParam() {
  const url = new URL(window.location.href);
  url.searchParams.delete('openJourneyForm');
  window.history.replaceState({}, '', url.toString());
}
